/** 与后端 inventoryService.USAGE_AREAS / MySQL 枚举一致 */
export const INVENTORY_USAGE_AREAS = ['吧台库存', '后厨库存', '其他库存']
